import { NexusEvaluationPeriod } from './types';

export const NexusEvaluationPeriodNameMap = {
  [NexusEvaluationPeriod.PREVIOUS_CALENDAR_YEAR]: 'Previous Calendar Year',
  [NexusEvaluationPeriod.PREVIOUS_OR_CURRENT_CALENDAR_YEAR]:
    'Previous or Current Calendar Year',
  [NexusEvaluationPeriod.PRECEDING_12_MONTHS]: 'Preceding 12 Months',
  [NexusEvaluationPeriod.PRECEDING_FISCAL_YEAR]: 'Preceding Fiscal Year',
  [NexusEvaluationPeriod.PRECEDING_12_MONTHS_ENDING_SEPT_30]:
    'Preceding 12 Months Ending Sept 30',
};
